export class SettingsMasterPasswordModel {
  enabled: boolean;
  value: string;
  protectCLIWithMasterPassword: boolean;

  constructor() {
    this.enabled = false;
    this.value = '';
    this.protectCLIWithMasterPassword = false;
  }
}
